import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { storeUser, updateUser } from '../../../../../../../redux/actions/users'
import { formValidator, resetFormValidator } from '../../../../../../../redux/actions/validator'
import { IRootState } from '../../../../../../../redux/types'
import { ROLES } from '../../../../models/user'

export function useHandleCreateForm(user: any) {
  const dispatch = useDispatch()

  const { isValidForm } = useSelector((state: IRootState) => state.validator)

  useEffect(() => {
    if (isValidForm) {
      dispatch(resetFormValidator())

      if (user.id === 0) dispatch(storeUser(user))
      else dispatch(updateUser(user))
    }
  }, [isValidForm])

  const handleSubmit = () => {
    if (user.role_id === ROLES.manager) {
      dispatch(
        formValidator({
          name: [user.name, 'required|max:45|min:2'],
          email: [user.email, 'required|max:45|min:5', 'general'],
          role_id: [user.role_id, 'required|max:45|min:2', 'general'],
          countries: [user.countries, 'notempty', 'work'],
          country: [user.country, 'notempty', 'general'],
          province: [user.province, 'notempty', 'general'],
          town: [user.town, 'notempty', 'general'],
          languages: [user.languages, 'notempty', 'general']
        })
      )
    } else if (user.role_id === ROLES.client) {
      dispatch(
        formValidator({
          name: [user.name, 'required|max:45|min:2'],
          role_id: [user.role_id, 'required|max:45|min:2', 'general'],
          languages: [user.languages, 'notempty', 'general'],
          email: [user.email, 'required|max:45|min:5', 'general'],
          phone: [user.phone, 'required|max:45|min:6', 'general'],
          centerName: [user.centerName, 'required|max:50|min:2', 'center'],
          countries: [user.countries, 'notempty', 'center'],
          province: [user.province, 'notempty', 'general'],
          town: [user.town, 'notempty', 'general']
        })
      )
    } else {
      dispatch(
        formValidator({
          name: [user.name, 'required|max:45|min:2'],
          email: [user.email, 'required|max:45|min:5', 'general'],
          role_id: [user.role_id, 'required|max:45|min:2', 'general'],
          countries: [user.countries, 'notempty', 'work'],
          country: [user.country, 'notempty', 'general'],
          province: [user.province, 'notempty', 'general'],
          town: [user.town, 'notempty', 'general'],
          languages: [user.languages, 'notempty', 'general']
        })
      )
    }
  }

  return { handleSubmit }
}
